import "./styles.css";
import { createEngine, clearBlack, drawVignette } from "./canvas/engine";
import { createUnicodeArt } from "./canvas/unicodeArt";
import { createEye } from "./canvas/eye";
import { createScene } from "./canvas/scene";
import { createPointer } from "./input/pointer";

const canvas = document.querySelector<HTMLCanvasElement>("#portal");
if (!canvas) {
  throw new Error("#portal canvas not found");
}

const engine = createEngine(canvas);
const pointer = createPointer(window);
const art = createUnicodeArt();
const eye = createEye();
const scene = createScene(art, eye);

engine.start((dt, now) => {
  const { ctx, width, height } = engine;
  clearBlack(ctx, width, height);
  scene.update(dt, now, pointer.state, width, height);
  scene.draw(ctx, width, height);
  drawVignette(ctx, width, height);
});

// Clean up on HMR / unload.
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    engine.dispose();
    pointer.dispose();
  });
}
